import React, {useEffect}  from 'react'
import {Link} from 'react-router-dom'


const TcAboutusmain = () => {

  useEffect(()=>{

   addressget()
   getContent()
 
 },[])

  function addressget(){
   
    fetch('https://localhost:44312/Api/Tc/GetTcUserAddress', {
     
    method:'GET',
  
      headers : {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
        //"Authorization": bearer,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },
  
  //body:JSON.stringify(data)
  
  }).then(response => response.json())
  .then(data => {
  console.log("Data",data)
  localStorage.setItem("TcAddressData", JSON.stringify(data));
  
  });
  
  }
  function getContent(){
   
    fetch('https://localhost:44312/Api/Tc/GetTcUserContent', {
     
    method:'GET',
  
      headers : {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
        //"Authorization": bearer,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },
  
  //body:JSON.stringify(data)
  
  }).then(response => response.json())
  .then(data => {
  console.log("Data",data)
 
  localStorage.setItem("TcContentpageData", JSON.stringify(data));

  });
  
  
  }
return(
    <>
 
        <div className='TC-addmain'>  
      
    <div className="TC-addgrid-layout">
  <div className="TC-addmain-top">
  <div className='TC-addmain-back'>
    <Link to='/Tcsection'><i className="fa-sharp fa-solid fa-backward"></i></Link>
    </div> 
    <span> AboutUs </span>
    </div>
    </div>

   
    <div className='Tc-addmainaboutusPic'>
    <div class="letter-image">
	<div class="animated-mail">
		<div class="back-fold"></div>
		<div class="letter">
    <div class="letter-border"></div>
		<p id="Aboutus-list"><Link to="/TcAddress"> <i class="fa fa-address-card" aria-hidden="true"></i>&nbsp;&nbsp;Address</Link></p>
		
				<p id="Aboutus-list"><Link to="/TcContent"><i class="fa fa-file" aria-hidden="true"></i>&nbsp;&nbsp;Content</Link></p> 
        <div class="letter-title"></div>
			<div class="letter-context"></div>

      <div class="letter-stamp">
				<div class="letter-stamp-inner"></div>
			</div> 
		</div>
		<div class="top-fold"></div>
		<div class="body"></div>
		<div class="left-fold"></div>
	</div>
	<div class="shadow"></div>
</div>

    </div>
    </div>

   
    </>
)
}

export default TcAboutusmain;